import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { cacheDatabase } from "@/api/firebase/firebase.config";

export const useUpdatePickedWinnerUserData = () => {
  const tenantId = brand.tenantId || "";

  const updateWinner = async ({ challengeId, winnerUid }) => {
    if (!tenantId) throw new Error("Tenant ID is not set");

    const ref = cacheDatabase
      .ref("picked-winners")
      .child(tenantId)
      .child(challengeId)
      .child(winnerUid);

    try {
      await ref.update({
        collected: true,
      });
      console.log("Winner updated successfully");
    } catch (error) {
      console.error("Error updating winner:", error);
      throw error;
    }
  };

  return { updateWinner };
};
